import React, { useState, useEffect } from "react";
import Loading from "@/app/core/layouts/main/components/Loading";
import Storage from "@/app/core/util/Storage";
import { ToastContainer, toast } from "react-toastify";
import MegaBanner from "../panels/MegaBanner";
import { GeneralHelper } from "@/app/core/util/helpers/GeneralHelper";
import CheckMobile from "@/app/core/util/Screen";

export default function MainDashboard() {
  const userData = Storage.getUserData();
  const [loading] = useState(false);
  const enviroment = process.env.REACT_APP_ENV;

  useEffect(() => {
    loadAutomations();
  }, []);

  async function loadAutomations() {
    GeneralHelper.UpdateMetaTags("Home", "Plataforma para ajudá-lo a mediar reclamações com empresas no Rio")
    if (enviroment == "local" || enviroment == "staging") {
    }
  }

  return (
    <>
      <MegaBanner />
      <div>

        <div className={CheckMobile() ? "row m-0" : "row ml-5 mr-5"} style={{ marginTop: -40, zIndex:1 }}>
          <div className="col-4 m-0 p-0">
            <div className="block block-rounded bg-warning" style={{height: 313}}>
              <div className="block-content text-center py-5">
                <img src={process.env.PUBLIC_URL + "/assets/media/megaphone.png"} />
              </div>
              <div className="block-content block-content-full block-content-sm bg-black-25 text-white text-center font-size-sm" style={{height: 146}}>
                Busque a empresa desejada, Faça sua reclamação publicamente.
              </div>
            </div>
          </div>
          <div className="col-4 m-0 p-0">
            <div className="block block-rounded bg-warning" style={{height: 313}}>
              <div className="block-content text-center py-5">
                <img src={process.env.PUBLIC_URL + "/assets/media/delivery.png"} />
              </div>
              <div className="block-content block-content-full block-content-sm bg-black-25 text-white text-center font-size-sm" style={{height: 146}}>
                Notificaremos a empresa com sua reclamação sempre que possível.
              </div>
            </div>
          </div>
          <div className="col-4 m-0 p-0">
            <div className="block block-rounded bg-warning" style={{height: 313}}>
              <div className="block-content text-center py-5">
                <img src={process.env.PUBLIC_URL + "/assets/media/deal.png"} />
              </div>
              <div className="block-content block-content-full block-content-sm bg-black-25 text-white text-center font-size-sm" style={{height: 146}}>
                A empresa entra em contato com você por aqui para resolver o seu problema.
              </div>
            </div>
          </div>

        </div>
      </div>
      <Loading loading={loading} />
      <ToastContainer className="toastr" />
    </>
  );
}
